import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "semantic-ui-css/semantic.min.css";

import "./config/i18n";

const includeUXScript = () => {
  const filename = "https://opentech-ux.org/lom-captor/dist/opentech-ux-lib.js";
  var head = document.getElementsByTagName("head")[0];
  let script = document.createElement("script");
  script.src = filename;
  script.setAttribute("data-endpoint", "https://likewatt.ux-key.com/endpoint");
  script.async = true;
  script.type = "text/javascript";

  head.appendChild(script);
};

if (process.env.REACT_APP_ENV !== "production") {
  window.hsConversationsSettings = {
    loadImmediately: false,
  };
}

if (
  process.env.REACT_APP_ENV === "production" &&
  process.env.REACT_APP_DEBUG === "false"
) {
  includeUXScript();
  console.log = () => {};
  console.warn = () => {};
}

// Google Analytics conditionnel

const trackingId = process.env.REACT_APP_GA_TRACKING_ID; // "G-BP28LQ3X2B"

const script = document.createElement("script");
script.async = true;
script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
document.head.appendChild(script);

script.onload = () => {
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", trackingId);
};

if (module.hot) module.hot.accept();

ReactDOM.render(
  <App />,

  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
